// ═══════════════════════════════════════════════════════
// ErrorBoundary.jsx — catches unexpected crashes in any child
// component and shows a clean recovery screen instead of a blank
// white page. Wrap the whole app with this in main.jsx.
// ═══════════════════════════════════════════════════════

import React from 'react'

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props)
    this.state = { hasError: false }
  }

  static getDerivedStateFromError() {
    return { hasError: true }
  }

  componentDidCatch(error, info) {
    // Log for debugging; in future this can be sent to a logging service.
    console.error('App crash caught by ErrorBoundary:', error, info)
  }

  handleReload = () => {
    this.setState({ hasError: false })
    window.location.reload()
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          minHeight: '100vh', background: '#080808', display: 'flex',
          flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
          padding: '32px', textAlign: 'center',
          fontFamily: 'Inter, system-ui, sans-serif',
        }}>
          <img src="/SYNINN_bg_remove_logo.png" alt="SYNINN"
            style={{ width: '80px', mixBlendMode: 'screen', opacity: 0.6, marginBottom: '24px' }} />
          <div style={{ fontSize: '40px', marginBottom: '14px' }}>⚠️</div>
          <div style={{
            fontFamily: 'Cormorant Garamond, Georgia, serif', fontSize: '24px',
            fontWeight: 300, color: '#F5F0E8', letterSpacing: '1px', marginBottom: '8px',
          }}>Something went wrong</div>
          <div style={{ width: '24px', height: '1px', background: '#C9A84C', margin: '0 auto 16px' }} />
          <div style={{ fontSize: '13px', color: '#888', lineHeight: 1.7, maxWidth: '280px', marginBottom: '28px' }}>
            The app hit an unexpected error. Please try again — your data is safe.
          </div>
          <button onClick={this.handleReload} style={{
            padding: '13px 32px', background: 'rgba(201,168,76,0.12)',
            border: '1px solid rgba(201,168,76,0.35)', color: '#C9A84C',
            borderRadius: '10px', fontSize: '14px', fontWeight: 600, cursor: 'pointer',
            fontFamily: 'Inter, system-ui, sans-serif',
          }}>Reload App</button>
        </div>
      )
    }
    return this.props.children
  }
}